<script setup lang="ts">
import { ref } from "vue";
import { useTranslation } from "i18next-vue";

import { useComponentErrorCapture } from "@/mixins/error";
import translatedProperty from "@/mixins/translatedProperty";

import SelectedIcon from "@/components/elements/icon/SelectedIcon.vue";
import Dialog from "@/components/elements/Dialog.vue";

const { t } = useTranslation();
useComponentErrorCapture();

const props = defineProps({
  macro: {
    type: Object,
    required: true,
  },
});
const emit = defineEmits(["goto", "clone", "delete"]);

const dialogDeleteMacro = ref();

function goto() {
  emit('goto');
}

function clone() {
  emit('clone', props.macro);
}

function startDelete() {
  dialogDeleteMacro.value.open();
}

function deleteItem() {
  emit('delete');
}

</script>
<template>
  <div 
    class="ent-item"
    @click="goto">
    <div class="ent-item__header">
      <SelectedIcon :icon="macro.icon || 'uc:macro'" />
    </div>
    <div class="ent-item__text">
      <h3 class="ent-item__title">{{ translatedProperty(macro.name) }}</h3>
    </div>
    <div class="ent-item__footer">
      <div class="ent-item__attributes">
        <span class="ent-item__attribute">
          <i class="fa-light fa-list-ul"></i>
        </span> 
      </div>
      <div class="ent-item__options">
        <button
          @click.stop="clone"
          class="button button--secondary button--icon button--icon--medium">
          <i class="fa-light fa-clone"></i>
        </button>
        <button
          @click.stop="startDelete"
          class="button button--delete button--icon button--icon--medium">
          <i class="fa-light fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
  <Dialog
    ref="dialogDeleteMacro"
    @submit="deleteItem"
    :title="$t('macro.delete.title')"
    :text="$t('macro.delete.question')"
    :submit-text="$t('ui.delete')"
    :cancel-text="$t('ui.cancel')"
  />
</template>
